import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
  animation: fade-in 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  flex: 1;
`;

export const PaperTitle = styled.div`
  padding: 8px;
  opacity: 0.7;
`;

export const Paper = styled.div`
  margin: 0 0 24px;
  background: #fafafa;
  padding: 8px 0;
  box-shadow: 0px 2px 13px -5px rgba(0, 0, 0, 0.12), 0px 1px 2px 1px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding: 4px 12px;
`;

export const Border = styled.div`
  border-bottom: 1px solid #a5a5a5;
  margin: 8px 0;
`;

export const Button = styled.button<{
  disabled?: boolean;
  color?: string;
}>`
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  display: flex;
  width: 100%;
  font-size: 18px;
  border: 1px solid #fff;
  justify-content: center;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  align-items: center;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: 0px 2px 13px -5px rgba(0, 0, 0, 0.12), 0px 1px 2px 1px rgba(0, 0, 0, 0.2);
  color: ${({ color }) => (color ? color : '#000')};
`;

export const RefundButton = styled(Button)`
  flex-grow: 1;
  height: 48px;
  border: 1px solid rgb(255, 255, 255, 0.3);
  color: #fff;
  font-weight: bold;
  background: #f5416e;
`;

export const PayButton = styled(RefundButton)`
  background: #37de61;
`;
